import * as types from './types';
import axios from 'axios';

const RTO_URL = "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/rent-to-own";
const RTO_KEY = "pVNXIov86ZkPVyDo8v787bgNIlh40Ve1C4Cdxg2a";
const RTO_HEADER = {
    "X-API-Key": RTO_KEY,
}


export default {
    [types.ACTIONS_UPDATE_ZIPCODE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_ZIPCODE, payload)
    },
    [types.ACTIONS_UPDATE_CONTAINER_LIST]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CONTAINER_LIST, payload)
    },
    [types.ACTIONS_UPDATE_CART_LIST]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CART_LIST, payload)
    },
    [types.ACTIONS_UPDATE_CART_CUSTOMATTRIBUTE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CART_CUSTOMATTRIBUTE, payload)
    },
    [types.ACTIONS_UPDATE_CART_CSCSURVEY]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CART_CSCSURVEY, payload)
    },
    [types.ACTIONS_DELETE_CART_CSCSURVEY]: ({ commit }, payload) => {
        commit(types.MUTATE_DELETE_CART_CSCSURVEY, payload)
    },
    [types.ACTIONS_REMOVE_CARTITEM]: ({ commit }, payload) => {
        commit(types.MUTATE_REMOVE_CARTITEM, payload)
    },
    [types.ACTIONS_UPDATE_RESETCART]: ({ commit }) => {
        commit(types.MUTATE_UPDATE_RESETCART)
    },
    [types.ACTIONS_UPDATE_TYPE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_TYPE, payload)
    },
    [types.ACTIONS_UPDATE_PURPOSE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PURPOSE, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY, payload)
    },
    [types.ACTIONS_UPDATE_CSC_TERMS]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CSC_TERMS, payload)
    },
    [types.ACTIONS_UPDATE_CSC_SURVEY]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CSC_SURVEY, payload)
    },
    [types.ACTIONS_UPDATE_CURRENTSURVEYOBJECT]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CURRENTSURVEYOBJECT, payload)
    },
    [types.ACTIONS_UPDATE_CURRENTSURVEY_PURPOSE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CURRENTSURVEY_PURPOSE, payload)
    },
    [types.ACTIONS_UPDATE_CURRENTSURVEY_TYPE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_CURRENTSURVEY_TYPE, payload)
    },
    [types.ACTIONS_UPDATE_TERMSCHECKBOX]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_TERMSCHECKBOX, payload)
    },
    [types.ACTIONS_UPDATE_LINEITEMHAULERPRICE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_LINEITEMHAULERPRICE, payload)
    },
    [types.ACTIONS_UPDATE_LINEITEMMARKET]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_LINEITEMMARKET, payload)
    },
    [types.ACTIONS_UPDATE_PREDELIVERYANSWERS]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PREDELIVERYANSWERS, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_DOORDIRECTION]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_DOORDIRECTION, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_SPACE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_SPACE, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_RUSTACKNOWLEDGE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_RUSTACKNOWLEDGE, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_INSTRUCTIONS]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_INSTRUCTIONS, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_NAME]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_NAME, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_PHONE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_PHONE, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_NONACCEPTABLEDATES]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_NONACCEPTABLEDATES, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_SURFACETYPE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_SURFACETYPE, payload)
    },
    [types.ACTIONS_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_DELIVERY_SOFTSURFACEACKNOWLEDGE, payload)
    },
    [types.ACTIONS_UPDATE_PREPICKUPANSWERS]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PREPICKUPANSWERS, payload)
    },
    [types.ACTIONS_UPDATE_PICKUP_RUSTACKNOWLEDGE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PICKUP_RUSTACKNOWLEDGE, payload)
    },
    [types.ACTIONS_UPDATE_PICKUP_INSPECTION]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PICKUP_INSPECTION, payload)
    },
    [types.ACTIONS_UPDATE_PICKUP_INSTRUCTIONS]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PICKUP_INSTRUCTIONS, payload)
    },
    [types.ACTIONS_UPDATE_PICKUP_NAME]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_PICKUP_NAME, payload)
    },
    [types.ACTIONS_UPDATE_FEEDBACKGIVEN]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_FEEDBACKGIVEN, payload)
    },
    [types.ACTIONS_UPDATE_COUNTRYCODE]: ({ commit }, payload) => {
        commit(types.MUTATE_UPDATE_COUNTRYCODE, payload)
    },
    async [types.ACTIONS_CALCULATE_RTOAMOUNT](context, payload) {        
        let response = await axios.get(
            RTO_URL,
            {
                headers: RTO_HEADER,
                params: {
                    Cash_Price: payload
                }
            }
        )        
        return response;        
    },
};